import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import type { ChatbotConversationsListOptions } from '../chatbotConversationsListParams';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotConversationsQuery(
  chatbotId: string | undefined,
  listOptions: ChatbotConversationsListOptions,
  enabled = true,
) {
  const { user } = useAuth();
  const resolvedChatbotId = chatbotId?.trim() ?? '';
  const isEnabled = enabled && Boolean(user) && resolvedChatbotId.length > 0;

  return useQuery({
    queryKey: chatbotQueryKeys.conversations(resolvedChatbotId, listOptions),
    enabled: isEnabled,
    queryFn: () =>
      chatbotService.listConversations(resolvedChatbotId, listOptions),
  });
}
